import { supabase } from './supabase.js';

export const PARTNER_NOTICIAS_IMAGENES_BUCKET = 'noticias-imagenes';

/** Prefijo de objeto en Storage: `partner-news/{partner_id}/...` */
export function partnerNewsImageObjectPath(partnerId, noticiaId, ext) {
  const pid = String(partnerId ?? '').trim();
  const nid = String(noticiaId ?? '').trim();
  const e = String(ext ?? 'jpg').replace(/^\./, '');
  if (!pid || !nid) return null;
  return `partner-news/${pid}/${nid}.${e}`;
}

/**
 * @param {string} partnerId
 * @returns {Promise<{ data: object[], error: string|null }>}
 */
export async function fetchPartnerNewsDrafts(partnerId) {
  if (!partnerId) return { data: [], error: 'missing_partner' };
  const { data, error } = await supabase
    .from('noticias_musica')
    .select(
      'id,titulo,extracto,categoria,tiempo_lectura,imagen_url,publicado,created_at,updated_at,metadata'
    )
    .eq('publicado', false)
    .order('created_at', { ascending: false })
    .limit(50);
  if (error) {
    console.error('[partnerNewsService] fetch drafts:', error.message);
    return { data: [], error: error.message };
  }
  const rows = (data ?? []).filter(
    r => r?.metadata?.source === 'partner' && String(r?.metadata?.partner_id ?? '') === String(partnerId)
  );
  return { data: rows, error: null };
}

/**
 * @param {{ partnerId: string, titulo: string, extracto?: string|null, categoria: string, contenido_html: string, tiempo_lectura?: string|null, imagen_url?: string|null }} p
 * @returns {Promise<{ row: object|null, error: string|null }>}
 */
export async function insertPartnerNewsDraft(p) {
  if (!p?.partnerId || !p?.titulo?.trim()) return { row: null, error: 'Datos incompletos' };
  const metadata = {
    source: 'partner',
    partner_id: p.partnerId,
    submitted_at: new Date().toISOString(),
  };
  const { data, error } = await supabase
    .from('noticias_musica')
    .insert({
      titulo: p.titulo.trim(),
      extracto: p.extracto?.trim() ? p.extracto.trim() : null,
      categoria: p.categoria,
      contenido_html: p.contenido_html ?? '',
      tiempo_lectura: p.tiempo_lectura?.trim() ? p.tiempo_lectura.trim() : null,
      imagen_url: p.imagen_url?.trim() ? p.imagen_url.trim() : null,
      publicado: false,
      destacado: false,
      metadata,
    })
    .select('id')
    .maybeSingle();
  if (error) {
    console.error('[partnerNewsService] insert:', error.message);
    return { row: null, error: error.message };
  }
  return { row: data ?? null, error: null };
}

/**
 * @param {string} noticiaId
 * @param {string} imagenUrl
 */
export async function updatePartnerNewsDraftImageUrl(noticiaId, imagenUrl) {
  if (!noticiaId) return { error: 'missing_id' };
  const { error } = await supabase.from('noticias_musica').update({ imagen_url: imagenUrl }).eq('id', noticiaId);
  if (error) {
    console.error('[partnerNewsService] update image:', error.message);
    return { error: error.message };
  }
  return { error: null };
}
